module.exports = __webpack_public_path__ + "static/media/Slide8.bc792180.png";